module.exports = __webpack_public_path__ + "images/accents/accent-team-administration@2x-c0edf727b768b42122de98d6af752e59.webp";